export const returnClosestNumberInRange = (value, minRange, maxRange) => {
  if (value < minRange) {
    return minRange;
  }
  if (value > maxRange) {
    return maxRange;
  }
  return value;
};